import { Check, X, AlertTriangle, CircleDot } from "lucide-react";

export const STATUS_META = {
  compliant: { label: "Compliant", cls: "bg-emerald-100 text-emerald-900 border-emerald-300", Icon: Check },
  non_compliant: { label: "Non-compliant", cls: "bg-red-100 text-red-900 border-red-300", Icon: X },
  draft: { label: "Incomplete", cls: "bg-amber-100 text-amber-900 border-amber-300", Icon: AlertTriangle },
};

const StatusChip = ({ status, testid }) => {
  const meta = STATUS_META[status] || STATUS_META.draft;
  const { Icon } = meta;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-bold border-2 tracking-wide uppercase ${meta.cls}`}
    >
      <Icon size={14} strokeWidth={3} />
      {meta.label}
    </span>
  );
};

export default StatusChip;
export const TriStateChip = ({ value, testid }) => {
  if (value === "yes") return <span data-testid={testid} className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold bg-emerald-100 text-emerald-900 border border-emerald-300"><Check size={12} strokeWidth={3}/>YES</span>;
  if (value === "no") return <span data-testid={testid} className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold bg-red-100 text-red-900 border border-red-300"><X size={12} strokeWidth={3}/>NO</span>;
  if (value === "na") return <span data-testid={testid} className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold bg-slate-100 text-slate-800 border border-slate-300"><CircleDot size={12} strokeWidth={3}/>N/A</span>;
  return <span data-testid={testid} className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold bg-amber-100 text-amber-900 border border-amber-300"><AlertTriangle size={12} strokeWidth={3}/>Pending</span>;
};
